import EL, { HTMLELEMENT } from '../../EL/EL.js';
import Hideable, { Hide, Show } from '../../../interface/Hideable.js';
import Switchable, { AbstractMethodError, Activate, Deactivate, MissingContainerError, RecursionLimitError } from '../../../interface/Switchable.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
// Model Structure
export const groupAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['style']
]);
export const groupData = makeDataStruct([
    ['children', []]
]);
export const groupModel = makeStruct([
    ['attributes', groupAttr],
    ['data', groupData]
]);
/** A group acts as a named, Switchable element used for grouping items */
export default class GROUP extends EL {
    constructor(node, element = HTMLELEMENT.DIV, model) {
        super(node, element, model);
        this.addClass('group');
        this.implement(new Hideable(this));
        this.implement(new Switchable(this));
    }
}
export { AbstractMethodError, Activate, Deactivate, EL, GROUP, Hide, Hideable, MissingContainerError, RecursionLimitError, Show };
